import { useApplicationLabels } from "~/hooks/useApplicationLabels";
import { createFileRoute } from "@tanstack/react-router";
import { ApplicationsPage } from "./-pages/applicationsPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/applications/list")({
  component: ApplicationsComponent,
});

function ApplicationsComponent() {
  const { datasetSlug } = Route.useParams();
  const applicationTerm = useApplicationLabels();
  useBreadCrumbs([{ title: applicationTerm.plural, link: `/${datasetSlug}/data/applications/list` }]);

  return <ApplicationsPage key={datasetSlug} datasetSlug={datasetSlug} />;
}
